import React, { useEffect, useState } from "react";
import "./table.css";
//import instituciones from "../../json/instituciones.json"
import { API_BASE_URL } from "../../Config/config";
import axios from "axios";
import { Link } from "react-router-dom";
import Loading from "../shared/Loading/Loading";
import { cardHome, getDiasHome, apiDownloadExcelHome } from "../../service/Service";


const DataTable = () => {
  const [dataTable, setDataTable] = useState([]);
  const [cardsHome, setCardsHome] = useState([]);
  const [cardsCati, setCardsCati] = useState([]);
  const [cardsWeb, setCardsWeb] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [isloadingtabla, setIsLoadingtabla] = useState(false);

  useEffect(() => {
    const fetchcard = async () => {
      setIsLoading(true);

      try {
        const response = await cardHome();
        // console.log(response.data.data);
        const data = response.data.data;
        setCardsHome(data?.total);
        setCardsCati(data?.cati);
        setCardsWeb(data?.limesurvey);
      } catch (error) {
        // Manejo de errores
      }

      setIsLoading(false);
    };

    // const fetchDias = async () => {
    //   setIsLoadingtabla(true);

    //   try {
    //     const response = await getDiasHome();
    //     setDataTable(response.data.data);
    //   } catch (error) {
    //     // Manejo de errores
    //   }

    //   setIsLoadingtabla(false);
    // };

    // fetchDias();
    fetchcard();
  }, [])

  const downloadExcelHome = () => {
    apiDownloadExcelHome().then((res) => {
      if ( parseInt(res.status) === 200 ) {
        const {status, msg, data} = res.data;
        if (parseInt(status) === 200 ) {
          console.log(msg);
          window.open(data.url, '_blank');
        } else {
          console.log('Ocurrió un error al descargar los datos.', msg);
        }
      }
    });
  }
  
  return (
    <div>
      <div className="row" style={{ paddingTop: 50 }}>
        <h1 style={{ textAlign: 'center', fontSize: 30 }}>Total</h1>
        <div className="col-sm-3 mb-3 mb-sm-0" style={{ paddingLeft: 100 }}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Objetivo<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome?.objetivo}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome?.logrado}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>% Realizado<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome?.porcentaje_logrado}%</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>último día</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome?.logrado_ultimos_dia}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-3" style={{ paddingRight: 100 }}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>últimos 7 días</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHome?.logrado_ultimos_7_dias}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <br/>
      {/* Nuevo codigo */}
      <div className="row">
        <h1 style={{ textAlign: 'center', fontSize: 30 }}>Cati</h1>
        <div className="col-sm-3 mb-3 mb-sm-0" style={{ paddingLeft: 100 }}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Objetivo<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati?.objetivo}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati?.logrado}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>% Realizado<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati?.porcentaje_logrado}%</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>último día</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati?.logrado_ultimos_dia}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-3" style={{ paddingRight: 100 }}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>últimos 7 días</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsCati?.logrado_ultimos_7_dias}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <br/>
      <div className="row">
        <h1 style={{ textAlign: 'center', fontSize: 30 }}>Web</h1>
        <div className="col-sm-3 mb-3 mb-sm-0" style={{ paddingLeft: 100 }}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Objetivo<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb?.objetivo}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb?.logrado}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>% Realizado<br/>&nbsp;</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb?.porcentaje_logrado}%</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>último día</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb?.logrado_ultimos_dia}</p>
              )}
            </div>
          </div>
        </div>
        <div className="col-sm-3" style={{ paddingRight: 100 }}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Logrado<br/>últimos 7 días</h5>
              {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsWeb?.logrado_ultimos_7_dias}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Botón de descarga */}
      {/* <div style={{ textAlign: "right", paddingRight: 100 }}>
        <button className="btn btn-primary" onClick={downloadExcelHome}>
          Descargar Excel
        </button>
      </div> */}
      <br/>
      <br/>
    </div>
  );
};

export default DataTable;

